import BaseProxy from "../../base-proxy";

// UTILS
import notification from "@/utils/notifications";
import { get } from "lodash";

// CONSTANTS
import NOTIFICATION_CONSTANTS from "@/constants/notification-type-constants";
export default class DeleteSimpatraServiceProxy {
  constructor() {
    this.baseProxy = new BaseProxy();
  }

  async execute(query = "", config = {}) {
    const { queryParams = {}, notificationParams = {}, payload } = config;

    const backendUrl = await this.baseProxy.getSimpatraServiceUrl();
    const endpointUrl = `${backendUrl}/${query}`;

    try {
      const response = await this.baseProxy.deleteSimpatraServiceData(endpointUrl, queryParams, payload);
      this.handleSuccessNotification(notificationParams);
      return response;
    } catch (error) {
      return this.handleErrorNotification(error, notificationParams);
    }
  }

  handleSuccessNotification(notificationParams) {
    if (!notificationParams.displaySuccessMessage) return;

    const header = notificationParams.successNotificationHeader || "Successfully deleted!";
    const message = notificationParams.successNotificationMsg || "";
    notification(NOTIFICATION_CONSTANTS.SUCCESS, header, message);
  }

  handleErrorNotification(error, notificationParams) {
    const errorData = error.response?.data || {};
    const errorResponse = error.response || {};

    const errorMsgHeader = errorData.error || errorData.message || errorResponse.error || "Event failed due to error!";
    const unauthorizedMessages = ["invalid_token", "unauthorized"];
    const header = unauthorizedMessages.includes(errorMsgHeader) ? "Unauthorized Access!" : errorMsgHeader;

    const message = notificationParams.errorNotificationMsg || errorData.message || errorData.error_description || errorResponse.error_description || errorResponse.message || "";

    notification(NOTIFICATION_CONSTANTS.ERROR, header, message);

    if (notificationParams.returnError) {
      return errorResponse;
    }

    return {};
  }
}
